import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { oLike } from 'Lib/like/like';
import 'Bem/site/meetings/meetings';
import 'Bem/site/author-news-block/author-news-block';
import 'Bem/site/collections-slider/collections-slider';
import 'Bem/site/tabs/tabs';
import 'Bem/site/finder/finder';
import 'Bem/site/spoiler/spoiler';
import 'Bem/site/filter-row/filter-row';
import 'Bem/site/collection/collection';
import 'Bem/site/menu-left/menu-left';
import 'Bem/site/search-content/search-content';
import 'Bem/journal/journal-items/journal-items';

svgSpriteLoader('/site/authors/svg/sprite.svg?v=20180320');
oLike.init('.js-author-like');